import React, { useState, useEffect, useCallback } from 'react';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';
import ReadyFilters, { useReadyFilters } from '../../components/ReadyFilters';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const numFmt = n => { const v=Math.abs(n||0); return v ? v.toLocaleString('fa-IR') : '•'; };

/* فراخوانی API + رفرش توکن */
async function API(path,opts={}){
  const doFetch=()=>fetch(`/api/accounting${path}`,{headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts});
  let res=await doFetch();
  if(res.status===401){const rr=await fetch('/api/auth/token/refresh/',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({refresh:localStorage.getItem('refresh')})});if(rr.ok){const d=await rr.json();localStorage.setItem('access',d.access);res=await doFetch();}}
  return res.json();
}

/* استهلاک حفظ قدرت خرید */
export default function DepreciatoryReadyModal({ year, onClose, onAdded }) {
  const [rawRows,  setRawRows]  = useState([]);
  const [docDate,  setDocDate]  = useState('');
  const [sourceCount, setSourceCount] = useState(0);
  const [totalDebit,  setTotalDebit]  = useState(0);
  const [columns,     setColumns]     = useState([]);
  const [serverTotal,   setServerTotal]   = useState(0);
  const [serverHasMore, setServerHasMore] = useState(false);
  const [loadingMore,   setLoadingMore]   = useState(false);
  const [currentPage,   setCurrentPage]   = useState(1);
  const [loading,  setLoading]  = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [confirm,  setConfirm]  = useState(false);
  const [error,    setError]    = useState('');
  const [empty,    setEmpty]    = useState('');
  const [toast,    setToast]    = useState('');
  // فیلترهای همزمان: جستجو + هزینه‌ای/تملک + سال مالی (سمت سرور، فقط برای مشاهده)
  const f = useReadyFilters({ initialFy: year });
  const [kindSupported, setKindSupported] = useState(true);
  const viewYear = f.fyNum || year;                 // سال خالی = سال مالی جاری
  const viewQuery = [f.qDeb ? `q=${encodeURIComponent(f.qDeb)}` : '',
                     (f.kind==='0'||f.kind==='1') ? `program_type=${f.kind}` : ''].filter(Boolean).join('&');
  const filtersActive = !!(viewQuery || (f.fyNum && f.fyNum !== Number(year)));

  /* عرض ستون‌ها */
  const { TH } = useColumnResize([85,60,70,230,120,120,75,75,80,60,170,170,150,85,70]);

  const {
    visibleRows,
    shownCount, LoadMoreButton,
  } = useTablePagination({
    allRows: rawRows, pageSize: 200,
    searchFields: [],   // جستجو سمت سرور انجام می‌شود
    serverTotal, serverHasMore,
  });

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),4500); };

  useEffect(() => {
    API(`/documents/next-no/?year=${year}`).then(j => { if (j.ok) setDocDate(j.last_date||''); });
  }, [year]);

  /* خواندن فهرست از سرور */
  const load = useCallback(async () => {
    setLoading(true); setError(''); setEmpty(''); setRawRows([]); setConfirm(false);
    const j = await API(`/auto-document/depreciatory/preview/?year=${viewYear}&page=1${viewQuery?'&'+viewQuery:''}`);
    setLoading(false);
    if (j.ok) {
      setRawRows(j.data); setServerTotal(j.total||0); setServerHasMore(j.has_more||false);
      setCurrentPage(1); setSourceCount(j.source_count||0);
      setTotalDebit(j.total_debit||0); setColumns(j.columns||[]);
      setKindSupported(j.kind_supported !== false);
      if ((j.total||0) === 0) setEmpty(j.msg || 'اسنادی برای محاسبه استهلاک وجود ندارد');
    } else setError(j.msg);
  }, [viewYear, viewQuery]);

  /* ۲۰۰ ردیف بعدی */
  const loadMore = async () => {
    const nextPage = currentPage + 1;
    setLoadingMore(true);
    const j = await API(`/auto-document/depreciatory/preview/?year=${viewYear}&page=${nextPage}${viewQuery?'&'+viewQuery:''}`);
    setLoadingMore(false);
    if (j.ok) {
      setRawRows(prev => [...prev, ...j.data]);
      setServerTotal(j.total||0); setServerHasMore(j.has_more||false); setCurrentPage(nextPage);
    }
  };

  useEffect(() => { load(); }, [load]);

  /* ساخت سند */
  const createDoc = async () => {
    setSaving(true); setError('');
    const j = await API('/auto-document/depreciatory/create/', {
      method:'POST', body: JSON.stringify({ year, doc_date: docDate }),
    });
    setSaving(false); setConfirm(false);
    if (j.ok) { showToast(j.msg); onAdded&&onAdded(); load(); } else setError(j.msg);
  };

  const cell = v => (v===null||v===undefined) ? '—' : (v===0 ? '•' : toFa(v));

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>
        <div style={s.hdr}>
          <div>
            <div style={{fontSize:'15px',fontWeight:'700',color:'#fff'}}>📉 استهلاک حفظ قدرت خرید</div>
            <div style={{fontSize:'11px',color:'rgba(255,255,255,0.6)',marginTop:'2px'}}>
              بستن ثبت‌های ۲۱۰۰۴ و ۲۱۰۱۱ — ۲۱۰۱۱ ← ۴۶۰/۴۶۰۰۱ و ۲۱۰۰۴ ← ۱۵۰/۱۵۰۰۱ — سال مالی {toFa(year)}
            </div>
          </div>
          <button onClick={onClose} style={s.xBtn}>✕</button>
        </div>

        <div style={s.body}>
          {error && <div style={s.err}>⚠️ {error}</div>}
          {empty && !error && <div style={s.warn}>📭 {empty}</div>}

          <div style={{...s.card, background:'#fffdf5', border:'1.5px solid #f0e6c0'}}>
            <div style={{fontSize:'12px',fontWeight:'700',color:'#8d6e00',marginBottom:'8px'}}>🧾 سند جدید</div>
            <div style={{display:'flex',gap:'14px',flexWrap:'wrap',alignItems:'flex-end'}}>
              <div style={s.fld}>
                <label style={s.lbl}>تاریخ سند *</label>
                <JalaliDatePicker value={docDate} onChange={v=>setDocDate(v)} placeholder="تاریخ"/>
              </div>
              <div style={s.fld}>
                <label style={s.lbl}>شرح سند</label>
                <input value="استهلاک حفظ قدرت خرید" readOnly
                  style={{...s.inp,width:'230px',background:'#f5f5f5',color:'#666'}} />
              </div>
              <div style={{fontSize:'11px',color:'#555',flex:1,minWidth:'220px'}}>
                ⚠ کل مانده یکجا به سند تبدیل می‌شود — انتخاب ردیف ندارد
              </div>
            </div>
          </div>

          <ReadyFilters f={f} searchLabel="جستجو (شرح / کد معین)"
            kindDisabled={!kindSupported}
            kindTitle={kindSupported ? '' : 'سرفصل ۲۱۰۰۴/۲۱۰۱۱ ستون طرح/برنامه ندارد؛ فیلتر هزینه‌ای/تملک ممکن نیست'}>
            <button onClick={load} disabled={loading} style={s.btnS}>{loading?'⏳...':'↺ محاسبه مجدد'}</button>
            <span style={{fontSize:'11px',color:'#888'}}>{toFa(shownCount)} از {toFa(serverTotal)}</span>
          </ReadyFilters>
          {filtersActive && (
            <div style={{fontSize:'11px',color:'#8d6e00'}}>
              ⚠ فیلترها فقط برای مشاهده است؛ سند استهلاک همیشه از کل مانده سال مالی جاری ساخته می‌شود.
              برای ساخت سند فیلترها را پاک کنید.
            </div>
          )}

          <div style={{maxHeight:'46vh',overflow:'auto',borderRadius:'8px',boxShadow:'0 1px 6px rgba(0,0,0,0.1)'}}>
            <table style={{width:'100%',borderCollapse:'collapse',direction:'rtl',fontSize:'11px',tableLayout:'fixed'}}>
              {/* سرستون‌ها */}
              <thead>
                <tr>
                  <TH idx={0}>نوع آرتیکل</TH>
                  <TH idx={1}>کل</TH>
                  <TH idx={2}>معین</TH>
                  <TH idx={3} right>شرح</TH>
                  <TH idx={4} red>بدهکار</TH>
                  <TH idx={5} red>بستانکار</TH>
                  <TH idx={6}>نوع منبع</TH>
                  <TH idx={7}>نوع اعتبار</TH>
                  <TH idx={8}>اقلام انتقالی</TH>
                  <TH idx={9}>سال</TH>
                  <TH idx={10} right>برنامه/طرح</TH>
                  <TH idx={11} right>منبع اعتبار</TH>
                  <TH idx={12} right>پروژه</TH>
                  <TH idx={13}>ردیف بودجه</TH>
                  <TH idx={14}>قرارداد</TH>
                </tr>
              </thead>
              <tbody>
                {visibleRows.map((r,i)=>{
                  const isCounter = r.kind === 'counter';
                  return (
                  <tr key={i} title={r.attrs_text||''}
                    style={{background:isCounter?(i%2===0?'#f3f8ff':'#eaf2fd'):(i%2===0?'#fff':'#fafafa')}}>
                    <td style={{...s.td,fontSize:'10px',fontWeight:'700',color:isCounter?'#1565c0':'#8d6e00'}}>{r.kind_title}</td>
                    <td style={{...s.td,fontWeight:'700'}}>{toFa(r.account_coding_code)}</td>
                    <td style={{...s.td,fontWeight:'700'}}>{toFa(r.accounting_sub_coding_code)}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.remark}>{r.remark||'—'}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(r.debit)}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#1b5e20'}}>{numFmt(r.credit)}</td>
                    <td style={s.td}>{cell(r.sourcetype)}</td>
                    <td style={s.td}>{cell(r.credittype)}</td>
                    <td style={s.td}>{cell(r.transferitems)}</td>
                    <td style={s.td}>{cell(r.year)}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.programid_display}>{r.programid_display||cell(r.programid)}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.creditid_display}>{r.creditid_display||cell(r.creditid)}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.projectid_display}>{r.projectid_display||cell(r.projectid)}</td>
                    <td style={s.td}>{cell(r.subbudgetid)}</td>
                    <td style={s.td}>{cell(r.contractid)}</td>
                  </tr>);})}
                {!loading && visibleRows.length===0 && (
                  <tr><td colSpan={15} style={{...s.td,padding:'24px',color:'#999'}}>📭 مانده‌ای برای معین‌های ۲۱۰۰۴ و ۲۱۰۱۱ وجود ندارد</td></tr>
                )}
              </tbody>
            </table>
          </div>

          <LoadMoreButton onClick={loadMore} loading={loadingMore} />

          <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',flexShrink:0}}>
            {serverTotal>0 && <>
              <span style={s.badge('#1a2f50')}>گروه مبدأ: {toFa(sourceCount)}</span>
              <span style={s.badge('#8d6e00')}>آرتیکل: {toFa(serverTotal)}</span>
              <span style={s.badge('#b71c1c')}>جمع بدهکار: {numFmt(totalDebit)}</span>
              <span style={s.badge('#1b5e20')}>جمع بستانکار: {numFmt(totalDebit)}</span>
              <span style={s.badge('#555')}>ستون‌های سرفصل: {toFa(columns.length)}</span>
            </>}
            <button onClick={()=>setConfirm(true)} disabled={saving||serverTotal===0||!docDate||filtersActive}
              title={filtersActive?'برای ساخت سند فیلترها را پاک کنید':''}
              style={{...s.btnP,marginRight:'auto',opacity:(saving||serverTotal===0||!docDate||filtersActive)?0.4:1}}>
              {saving?'⏳...':'💾 ساخت سند استهلاک'}
            </button>
          </div>
        </div>

        {/* تأییدیه */}
        {confirm && (
          <div style={s.confirmWrap} onClick={()=>setConfirm(false)}>
            <div style={s.confirmBox} onClick={e=>e.stopPropagation()}>
              <div style={{fontSize:'14px',fontWeight:'700',color:'#0a1628',marginBottom:'6px'}}>هشدار</div>
              <div style={{fontSize:'13px',color:'#333',lineHeight:'1.9'}}>
                تعداد <b style={{color:'#b71c1c'}}>{toFa(serverTotal)}</b> آرتیکل در سند جدید ایجاد شود؟
                <div style={{fontSize:'11px',color:'#777',marginTop:'6px'}}>
                  تاریخ سند: {docDate||'—'} — شرح: استهلاک حفظ قدرت خرید
                </div>
              </div>
              <div style={{display:'flex',gap:'8px',marginTop:'14px',justifyContent:'flex-start'}}>
                <button onClick={createDoc} disabled={saving} style={s.btnP}>{saving?'⏳...':'بلی'}</button>
                <button onClick={()=>setConfirm(false)} style={s.btnS}>خیر</button>
              </div>
            </div>
          </div>
        )}

        {toast && <div style={{position:'absolute',bottom:'14px',right:'14px',background:'#1b5e20',
          color:'#fff',padding:'10px 20px',borderRadius:'8px',fontSize:'13px',fontWeight:'600',zIndex:10}}>{toast}</div>}
      </div>
    </div>
  );
}

/* استایل‌ها */
const s = {
  overlay:   {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:3000,display:'flex',alignItems:'center',justifyContent:'center',padding:'12px'},
  modal:     {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'1500px',maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden',position:'relative'},
  hdr:       {display:'flex',justifyContent:'space-between',alignItems:'flex-start',padding:'14px 18px',background:'linear-gradient(135deg,#0a1628,#1565c0)',flexShrink:0},
  xBtn:      {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  body:      {flex:1,overflowY:'auto',padding:'14px',display:'flex',flexDirection:'column',gap:'10px'},
  err:       {background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'7px',padding:'8px 12px',color:'#c62828',fontSize:'12px'},
  warn:      {background:'#fffde7',border:'1px solid #ffe082',borderRadius:'7px',padding:'8px 12px',color:'#8d6e00',fontSize:'12px'},
  card:      {background:'#fff',borderRadius:'10px',padding:'14px',boxShadow:'0 1px 4px rgba(0,0,0,0.08)'},
  fld:       {display:'flex',flexDirection:'column',gap:'3px'},
  lbl:       {fontSize:'11px',fontWeight:'600',color:'#555'},
  inp:       {padding:'7px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',fontSize:'12px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',boxSizing:'border-box'},
  td:        {padding:'5px 8px',fontSize:'11px',textAlign:'center',borderBottom:'1px solid #f0f0f0',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  btnP:      {padding:'9px 20px',background:'linear-gradient(135deg,#1565c0,#1976d2)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnS:      {padding:'8px 14px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px'},
  badge:     bg => ({padding:'4px 10px',background:bg,color:'#fff',borderRadius:'16px',fontSize:'11px',fontWeight:'700'}),
  confirmWrap:{position:'absolute',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:20},
  confirmBox:{background:'#fff',borderRadius:'12px',padding:'18px 22px',minWidth:'340px',boxShadow:'0 12px 40px rgba(0,0,0,0.4)',direction:'rtl'},
};
